import AbstractManipulator from "_src/client/manipulators/abstract_manipulator";

export default class View extends AbstractManipulator {

  constructor(camera) {
    super(camera);
  }

  cleanup() {
    super.cleanup();
  }

}
